import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../common/components/Input";
import { fabricateSet } from "../../../api/caseApi";
import { updateFabricationDate } from "../../../api/caseApi";
import { updateFabricationAndShipmentDateSchema } from "../schema/updateDueDateSchema copy";
const UpdateFabricationDateDialog = ({
  openUpdateFabricationDate,
  handleCloseUpdateFabricationDate,
  caseProgressId,
  getSetsInfo,
  openUpdateFabricationDateFromFabricateSet,
  handleSetOpenUpdateFabricationDateFromFabricateSet,
}) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(updateFabricationAndShipmentDateSchema),
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseProgressId = caseProgressId;
    // defaultValues.dateTime = f2fConsultationInfo.fabricationDate ?? null;
    reset({ ...defaultValues });
  }, [caseProgressId, reset]);

  const submitUpdateFabrication = async (values) => {
    await updateFabricationDate(values);
    if (openUpdateFabricationDateFromFabricateSet) {
      await fabricateSet(caseProgressId).then(() => {
        getSetsInfo();
      });
    } else {
      await getSetsInfo();
    }
    handleSetOpenUpdateFabricationDateFromFabricateSet();
    handleCloseUpdateFabricationDate();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateFabricationDate}
        onClose={handleCloseUpdateFabricationDate}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Fabrication Date</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateFabrication)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={7}>
                <DateInput
                  label="Date"
                  name="datetime"
                  control={control}
                  disableFuture={false}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              onClick={() => {
                handleCloseUpdateFabricationDate();
                handleSetOpenUpdateFabricationDateFromFabricateSet();
              }}
              disabled={isSubmitting}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateFabricationDateDialog;
